import React, { useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as api from '../api';
import MTODashboard from '../components/materialTakeoff/MTODashboard';
import MTONewTakeoff from '../components/materialTakeoff/MTONewTakeoff';
import MTORegister from '../components/materialTakeoff/MTORegister';
import MTOApprovalQueue from '../components/materialTakeoff/MTOApprovalQueue';
import MTOEditor from '../components/materialTakeoff/MTOEditor';

// Material Take-Off & Planning — the Base44 take-off hub.
//   /material-takeoff/:tab           dashboard | new | my-takeoffs | register | approvals | revisions
//   /material-takeoff/takeoff/:id    the take-off workspace (editor while draft/returned, review view otherwise)
const TABS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'new', label: 'New Take-Off' },
  { id: 'my-takeoffs', label: 'My Take-Offs' },
  { id: 'register', label: 'Take-Off Register' },
  { id: 'approvals', label: 'Approval Queue' },
  { id: 'revisions', label: 'Revision History' },
];

export default function MaterialTakeoffPage() {
  const navigate = useNavigate();
  const { tab = 'dashboard', id } = useParams();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || '';

  const goTo = useCallback((next, query) => {
    api.clearApiCache();
    const qs = query ? `?${new URLSearchParams(query).toString()}` : '';
    navigate(`/material-takeoff/${next}${qs}`);
  }, [navigate]);
  const openTakeoff = useCallback((takeoffId) => { api.clearApiCache(); navigate(`/material-takeoff/takeoff/${takeoffId}`); }, [navigate]);

  const inEditor = tab === 'takeoff' && id;
  const shown = inEditor ? null : (TABS.some(t => t.id === tab) ? tab : 'dashboard');

  return (
    <div className="fade-in" style={{ padding: '0 0 24px', marginTop: -28 }}>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${TABS.length}, minmax(0, 1fr))`, gap: 10, marginBottom: 20, paddingTop: 16 }}>
        {TABS.map(t => {
          const on = shown === t.id;
          return (
            <button key={t.id} onClick={() => goTo(t.id)} style={{
              padding: '18px 10px', background: on ? '#0b318bff' : 'var(--bg-card)', color: on ? '#fff' : 'var(--text-primary)',
              border: '1px solid black', borderRadius: 12, cursor: 'pointer', fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap',
              overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center',
              boxShadow: on ? '0 4px 12px rgba(11,49,139,0.2)' : 'var(--shadow-sm)', transition: 'all 0.2s ease',
            }}>{t.label}</button>
          );
        })}
      </div>

      <div style={{ background: 'var(--bg-card)', border: '3px solid black', borderRadius: 16, minHeight: 400, padding: 24, boxShadow: 'var(--shadow-sm)' }}>
        {inEditor && (
          <MTOEditor key={id} takeoffId={id}
                     onBack={() => goTo('register')}
                     onOpenTakeoff={openTakeoff}
                     onOpenMR={() => { api.clearApiCache(); navigate('/material-request/my-requests'); }} />
        )}
        {shown === 'dashboard' && <MTODashboard goTo={goTo} />}
        {shown === 'new' && <MTONewTakeoff onCreated={openTakeoff} />}
        {shown === 'my-takeoffs' && <MTORegister key="mine" mode="mine" initialStatus={status} onOpen={openTakeoff} />}
        {shown === 'register' && <MTORegister key="register" mode="register" initialStatus={status} onOpen={openTakeoff} />}
        {shown === 'revisions' && <MTORegister key="revisions" mode="revisions" initialStatus={status} onOpen={openTakeoff} />}
        {shown === 'approvals' && <MTOApprovalQueue onOpen={openTakeoff} />}
      </div>
    </div>
  );
}
